import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FileSignature, ArrowLeft } from "lucide-react";

const TEXT = {
  DRAFT: { title: "مطلوب: أكمل بيانات اتفاقية التعاون", body: "فرصك لن تُراجع أو تُنشر قبل إكمال بيانات الاتفاقية واعتمادها ثم توقيعها.", cta: "أكمل الاتفاقية" },
  PENDING_SIGNATURES: { title: "مطلوب: وقّع اتفاقية التعاون", body: "بيانات الاتفاقية معتمدة وبانتظار توقيعك الإلكتروني لتنتقل فرصك للمراجعة.", cta: "وقّع الاتفاقية" },
};

export default function AgreementAlert() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    api.get("/contracts/documents").then(({ data }) => {
      const open = (data.documents || []).find((d) => d.kind === "ASSOCIATION_AGREEMENT" && TEXT[d.state]);
      setDoc(open || null);
    }).catch(() => setDoc(null));
  }, []);

  if (!doc) return null;
  const t = TEXT[doc.state];
  return (
    <div className="mb-6 rounded-2xl border-2 border-rose-300 bg-rose-50 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="agreement-alert">
      <div className="h-12 w-12 shrink-0 rounded-xl bg-rose-600 text-white grid place-items-center"><FileSignature className="h-6 w-6" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-black text-rose-900" data-testid="agreement-alert-title">{t.title}</div>
        <p className="mt-1 text-sm text-rose-800 leading-6">{t.body}</p>
      </div>
      <Link to={`/dashboard/contracts?document=${doc.id}`} className="inline-flex items-center justify-center gap-2 min-h-11 px-5 rounded-xl bg-rose-700 text-white text-sm font-bold hover:bg-rose-600 shrink-0" data-testid="agreement-alert-cta">
        {t.cta} <ArrowLeft className="h-4 w-4" />
      </Link>
    </div>
  );
}
